import { render } from "./ColorSelectMenu.vue?vue&type=template&id=002a0ef6&scoped=true"
import script from "./ColorSelectMenu.vue?vue&type=script&lang=js"
export * from "./ColorSelectMenu.vue?vue&type=script&lang=js"

import "./ColorSelectMenu.vue?vue&type=style&index=0&id=002a0ef6&scoped=true&lang=scss"

import exportComponent from "/home/devops/tool_cases/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-002a0ef6"]])

export default __exports__